module.exports = __webpack_public_path__ + "img/paper_fail.fa0161b5.svg";